import Vue from "vue";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import VueCookies from "vue-cookies";
import AsyncComputed from "vue-async-computed";
import router from "./plugins/router";
import "./assets/styles/site.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { setLanguage } from "./locale/language"
import cookies from "./plugins/cookies";

Vue.use(VueGtag, {
    config: { id: "G-F2QZXD97FE" },
});

Vue.use(AsyncComputed);

Vue.config.productionTip = false;

Vue.use(VueCookies, { expires: "45d" });

const hostname = window.location.hostname.replace(/www\./, "");
cookies.set = (key, value) => {
    Vue.$cookies.set(key, value, "45d", null, hostname);
};
cookies.get = (key) => Vue.$cookies.get(key);
cookies.exists = (key) => Vue.$cookies.isKey(key);
cookies.remove = (key) => Vue.$cookies.remove(key, null, hostname);

// Remember Language
if (cookies.get('language')) {
    setLanguage(cookies.get('language'))
}

document.addEventListener("DOMContentLoaded", async function () {
    new Vue({
        router,
        render: (h) => h(App),
    }).$mount("#app");
});

